// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MultilingualUrl
 */
export interface MultilingualUrl {
  /**
   *
   */
  _default: string;
}

/**
 * Check if a given object implements the MultilingualUrl interface.
 */
export function instanceOfMultilingualUrl(value: object): value is MultilingualUrl {
  if (
    (!("_default" in (value as Record<string, any>)) &&
      !("default" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["_default"] === undefined &&
      (value as Record<string, any>)["default"] === undefined)
  )
    return false;
  return true;
}

export function MultilingualUrlFromJSON(json: any): MultilingualUrl {
  return MultilingualUrlFromJSONTyped(json, false);
}

export function MultilingualUrlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MultilingualUrl {
  if (json == null) {
    return json;
  }
  return {
    _default: json["default"],
  };
}

export function MultilingualUrlToJSON(json: any): MultilingualUrl {
  return MultilingualUrlToJSONTyped(json, false);
}

export function MultilingualUrlToJSONTyped(
  value?: MultilingualUrl | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    default: value["_default"],
  };
}
